const replaceNbsps = (str: string) => {
    const re = new RegExp(String.fromCharCode(160), 'g')
    return str.replace(re, ' ')
}
export function priceFormatter(price: number | null, currency = {
  iso: 'pl-PL',
  code: 'PLN',
  symbol: 'zł',
}) {
    if (price !== null && !isNaN(price)) {
        return replaceNbsps(
          price.toLocaleString(currency.iso, {
              style: 'currency',
              currency: currency.code,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
          }),
        )
    } else {
        console.warn(`[WARN - FRONT APP]: (price) value ${price} is NaN`)
    }
}
const paymentStatusTranslationKeys: Record<string, string> = {
    CREATED: 'invoices_details.payment_status.created',
    COMPLETED: 'invoices_details.payment_status.completed',
    CANCELED: 'invoices_details.payment_status.canceled',
    FAILED: 'invoices_details.payment_status.falied',
}

export function getPaymentStatusTranslationKey(status: string): string {
    return paymentStatusTranslationKeys[status] || ''
}

export function parcelLockerAddressFormatter(locker: any) {
    if (locker) {
        const { street, zipCode, city, country } = locker
        return locker && `${street}, ${zipCode}, ${city}, ${country}`
    }
    return ''
}
